export type { DirectiveProps, FencedDirective, MarkdownExtension } from "./parse";
export { parseFencedDirective } from "./parse";
import { pmcFigureExtension } from "./pmc_figure";
import { pmcTableExtension } from "./pmc_table";

/** All registered custom fenced-block extensions for MarkdownWithHighlight. */
export const EXTENSIONS = [pmcFigureExtension, pmcTableExtension];
